import React from "react";
import { NavLink } from "react-router-dom";
import SubjectCompassLogo from "assets/Subject Compass Logo.svg";
import UACLogoSmall from "assets/UAC-Logo-Small.png";
import "styles/DesktopNavbar.scss";

export default function DesktopNavbar() {
  return (
    <div className="desktop-navbar  desktop-only">
      <div>
        <NavLink to="/" name="/">
          <img
            className="desktop-navbar-uac-logo"
            src={UACLogoSmall}
            alt="Uac Logo"
          />
        </NavLink>
        <NavLink to="/">
          <img
            className="desktop-navbar-logo"
            src={SubjectCompassLogo}
            alt="Subject Compass Logo"
          />
        </NavLink>
      </div>

      <div className="flex">
        <div className="desktop-navbar-container-return">
          <a
            className="desktop-navbar-text"
            target="_blank"
            rel="noopener noreferrer"
            href="https://uac.edu.au"
          >
            Return to UAC website
          </a>
        </div>
      </div>
    </div>
  );
}
